import { render, staticRenderFns } from "./checkboxAgreement.vue?vue&type=template&id=77e2410c&"
import script from "./checkboxAgreement.vue?vue&type=script&lang=js&"
export * from "./checkboxAgreement.vue?vue&type=script&lang=js&"
import style0 from "./checkboxAgreement.vue?vue&type=style&index=0&id=77e2410c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports